import { render } from "./ApplyImplantStatement.vue?vue&type=template&id=64642c1e&scoped=true"
import script from "./ApplyImplantStatement.vue?vue&type=script&lang=js"
export * from "./ApplyImplantStatement.vue?vue&type=script&lang=js"

import "./ApplyImplantStatement.vue?vue&type=style&index=0&id=64642c1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64642c1e"]])

export default __exports__